import { render } from "./ActivateRestaurant.vue?vue&type=template&id=6b8d77ae&scoped=true"
import script from "./ActivateRestaurant.vue?vue&type=script&lang=js"
export * from "./ActivateRestaurant.vue?vue&type=script&lang=js"

import "./ActivateRestaurant.vue?vue&type=style&index=0&id=6b8d77ae&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8d77ae"]])

export default __exports__